import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'lib-flexible/flexible.js';
import useVant from './utils/vant';
import '@/assets/css/index.scss';

import VxeTable from 'vxe-table';
import 'vxe-table/lib/style.css';

// 返回组件
import BackRow from '@/components/back-row.vue';

// 3. 注册你需要的组件
const app = createApp(App);
app.component('BackRow', BackRow);
useVant(app);

app.use(VxeTable).use(store).use(router).mount('#app');
